import { countryFlag, countryName, PHONE_COUNTRIES, type PhoneCountry } from '../core/phone-country.ts';
import type { Lang } from '../i18n/index.ts';
import { Icon } from './icons.tsx';
import { cx } from './kit.tsx';
import '../styles/account.css';

/** Код страны перед номером: системный список лежит невидимым поверх подписи. */
export function CountryCodeMenu(props: { country: PhoneCountry; lang: Lang; label: string; onChange: (country: PhoneCountry) => void }) {
  return (
    <span className={cx('country-menu', 't-numeric')}>
      <span aria-hidden="true">{countryFlag(props.country)}</span>
      <span aria-hidden="true">{props.country.dialCode}</span>
      <Icon name="chevronDown" size={12} weight={2.6} className="t-muted" />
      <select
        aria-label={props.label}
        value={props.country.iso}
        onChange={(event) => {
          const next = PHONE_COUNTRIES.find((item) => item.iso === event.target.value);
          if (next) props.onChange(next);
        }}
      >
        {PHONE_COUNTRIES.map((item) => (
          <option key={item.iso} value={item.iso}>
            {countryFlag(item)} {countryName(item, props.lang)} {item.dialCode}
          </option>
        ))}
      </select>
    </span>
  );
}
